var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex message"},[_c('div',{staticClass:"message-label"},[_vm._v("用户留言：")]),_c('div',{staticClass:"flex-1"},[_vm._v(" "+_vm._s(_vm.data)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }